export const TEMPLATE_TYPE = {
  MULTI_COUNTRY: 'MC',
  SINGLE_COUNTRY: 'SC',
} as const;

export type TemplateType = (typeof TEMPLATE_TYPE)[keyof typeof TEMPLATE_TYPE];
